<template>
  <div class="">
    <div id="admin-preloader" v-if="loading">
      <div id="admin-loader-text">Loading</div>
      <div id="admin-loader"></div>
    </div>
    <div v-if="changed">
      <el-card
        shadow="always"
        style="background-color: #f5f7fa; overflow: initial; margin-top: 20px"
      >
        <b-row>
          <b-col sm="3" class="my-1">
            <b-form-group label="Year" class="mb-0">
              <!-- <month-picker-input
              style="z-index: 500"
              :no-default="false"
              :year-only="true"
              :show-year="true"
              @change="handleMonth"
              :default-year="new Date().getFullYear()"
              :max-date="new Date()"
              placeholder="Select Month"
            ></month-picker-input> -->
              <el-date-picker
                v-model="year"
                :picker-options="{ disabledDate: (time) => disabledDate(time) }"
                type="year"
                placeholder="Year"
                @change="
                  () => {
                    getGraphData();
                  }
                "
              >
              </el-date-picker>
            </b-form-group>
          </b-col>

          <b-col sm="3" class="my-1">
            <b-form-group label="Store Location" class="mb-0">
              <b-form-select
                placeholder="Store Location"
                v-model="storeLocation"
                :options="stores"
                @change="
                  (id) => {
                    storeLocation = id;
                    getGraphData();
                  }
                "
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col sm="3" class="my-1">
            <b-form-group label="Main Category" class="mb-0">
              <b-form-select
                placeholder="Main Category"
                v-model="mainCategory"
                :options="mainCategories"
                @change="
                  (value) => {
                    mainCategory = value;
                    subCategories = [
                      {
                        value: null,
                        text: 'Select Sub Category',
                        disabled: true,
                      },
                    ];
                    subCategory = null;
                    Object.keys(categories[mainCategory]).forEach(
                      (subcat, index) => subCategories.push(subcat)
                    );
                    getGraphData();
                  }
                "
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col sm="3" class="my-1">
            <b-form-group label="Sub Category" class="mb-0">
              <b-form-select
                placeholder="Sub Category"
                v-model="subCategory"
                :options="subCategories"
                @change="
                  (value) => {
                    subCategory = value;
                    getGraphData();
                  }
                "
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- <b-row>
        <b-col sm="12" class="my-1">
          <b-form-group label="" class="mb-0">
            <el-button
              style="margin: auto; display: block; margin-top: 10px"
              type="primary"
              size="medium"
              >Search</el-button
            >
          </b-form-group>
        </b-col>
      </b-row> -->
      </el-card>
      <el-card shadow="always" style="background-color: #dcdfe6" class="my-4">
        <h5 class="mb-3" style="text-align: center">Store Summary for Year</h5>
        <!-- Main table element -->
        <el-card style="overflow-x: scroll;" shadow="always">
          <b-table
            show-empty
            stacked="sm"
            :items="reports"
            :fields="summaryFields"
            :hover="true"
            head-variant="dark"
            empty-text="No records to show"
            class="mt-4"
          >
          </b-table>
        </el-card>
        <el-table
          :data="tableData"
          style="width: 100%; margin-top: 30px"
          row-key="id"
        >
          <el-table-column
            prop="category"
            label="Category"
            sortable
            width="260"
          >
          </el-table-column>
          <!-- <el-table-column prop="sales" label="Sales" sortable width="180">
      </el-table-column>
      <el-table-column prop="profit" label="Profit" sortable width="180">
      </el-table-column> -->
          <el-table-column
            v-for="(month, index) in months"
            :key="index"
            :label="month"
          >
            <el-table-column label="Sales LKR" width="100">
              <template slot-scope="scope">
                {{
                  scope.row.salesProfit[month]
                    ? scope.row.salesProfit[month].sales
                      ? `${scope.row.salesProfit[month].sales.toLocaleString()}`
                      : "-"
                    : "-"
                }}</template
              >
            </el-table-column>
            <el-table-column label="Profit LKR" width="100">
              <template slot-scope="scope">
                {{
                  scope.row.salesProfit[month]
                    ? scope.row.salesProfit[month].profit
                      ? `${scope.row.salesProfit[
                          month
                        ].profit.toLocaleString()}`
                      : "-"
                    : "-"
                }}
              </template>
            </el-table-column>

            <!-- <template v-if="scope.row.salesProfit[month]" slot-scope="scope">
          <el-tag size="small" type="info" style="color: #4b85fa">
            {{
              scope.row.salesProfit[month]
                ? scope.row.salesProfit[month].sales
                  ? `Sales: ${scope.row.salesProfit[
                      month
                    ].sales.toLocaleString()}`
                  : "-"
                : 0
            }}</el-tag
          >
          <el-tag size="small" type="info" style="color: #4b85fa">
            {{
              scope.row.salesProfit[month]
                ? `Profit: ${scope.row.salesProfit[
                    month
                  ].profit.toLocaleString()}`
                : 0
            }}</el-tag
          >
        </template> -->
          </el-table-column>
        </el-table>
      </el-card>
      <el-row style="margin-top: 20px" justify="space-between">
        <el-col :xs="24" :sm="24" :md="20" :lg="16" :xl="16" :offset="offset">
          <h5 class="text-secondary mb-3" style="text-align: center">
            Sales by Category per Month
          </h5>
          <el-card shadow="always" style="background-color: #233964">
            <AreaChart
              v-if="reports.length > 0"
              :areaChartDataset="datasets"
              :areaChartLabels="labels"
            />
            <div v-if="reports.length === 0">
              <p style="" class="text-white mx-auto">No Data</p>
            </div>
          </el-card>
        </el-col>
        <el-col :xs="24" :sm="24" :md="20" :lg="16" :xl="16" :offset="offset">
          <h5 class="text-secondary mt-5" style="text-align: center">
            Total Sales per Month
          </h5>
          <el-card
            class="mt-3"
            shadow="always"
            style="background-color: #263450"
          >
            <BarChart
              v-if="reports.length > 0"
              :barChartDataset="barChartDataset"
              :barChartLabels="labels"
            />
            <div v-if="reports.length === 0">
              <p style="" class="text-white mx-auto">No Data</p>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <div class="row mb-5 col-md-8" style="background-color: #eee"></div>
      <div class="row mb-5 col-md-8" style="background-color: #eee"></div>
    </div>
  </div>
</template>

<script>
import db from "../../config/FirebaseInit";
import firebase from "firebase/app";
import AreaChart from "../Charts/AreaChart.vue";
import BarChart from "../Charts/BarChart.vue";
import { MonthPickerInput } from "vue-month-picker";
export default {
  name: "analytics",
  components: {
    AreaChart,
    BarChart,
    MonthPickerInput,
  },
  data() {
    return {
      loading: false,
      changed: true,
      offset: 4,
      year: new Date().getFullYear().toString(),
      storeLocation: null,
      mainCategory: null,
      subCategory: null,
      shops: [],
      categories: {},
      reports: [],
      isReportExsists: true,
      analyticsReport: {},
      categories: "",
      gradient: null,
      gradient2: null,
      tableData: [],
      mainCategories: [
        { value: null, text: "Select Main Category", disabled: true },
      ],
      subCategories: [
        { value: null, text: "Select Sub Category", disabled: true },
      ],
      stores: [{ value: null, text: "Select Store Location", disabled: true }],
      labels: [],
      datasets: [],
      barChartDataset: [
        {
          label: "Sales",
          backgroundColor: "#f87979",
          data: [],
        },
      ],
      summaryFields: [
        { key: "month", label: "Month", sortable: false },
        { key: "totalPurcCost", label: "Total Purchase Cost", sortable: true },
        { key: "totalPurcDue", label: "Total Credit", sortable: true },
        { key: "totalRemaining", label: "Total Due", sortable: true },
        { key: "totalSales", label: "Total Sales", sortable: true },
        { key: "totalProfit", label: "Gross Profit", sortable: true },
        { key: "totalExp", label: "Total Expenses", sortable: true },
        { key: "netProfit", label: "Net Profit", sortable: true },
      ],
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      colorArray: [
        "rgba(208, 156, 221, 0.5)",
        "rgba(201, 246, 175, 0.5)",
        "rgba(213, 191, 255, 0.5)",
        "rgba(208, 230, 205, 0.5)",
        "rgba(226, 246, 169, 0.5)",
        "rgba(136, 173, 231, 0.5)",
        "rgba(255, 245, 169, 0.5)",
        "rgba(250, 199, 255, 0.5)",
        "rgba(103, 198, 156, 0.5)",
        "rgba(255, 162, 164, 0.5)",
        "rgba(82, 234, 244, 0.5)",
        "rgba(246, 160, 133, 0.5)",
        "rgba(96, 238, 234, 0.5)",
        "rgba(223, 159, 109, 0.5)",
        "rgba(105, 235, 255, 0.5)",
        "rgba(255, 190, 138, 0.5)",
        "rgba(50, 198, 189, 0.5)",
        "rgba(230, 151, 144, 0.5)",
        "rgba(166, 255, 222, 0.5)",
        "rgba(227, 150, 162, 0.5)",
        "rgba(179, 255, 208, 0.5)",
        "rgba(255, 193, 221, 0.5)",
        "rgba(160, 220, 157, 0.5)",
        "rgba(255, 191, 200, 0.5)",
        "rgba(102, 186, 168, 0.5)",
        "rgba(253, 211, 143, 0.5)",
        "rgba(128, 217, 255, 0.5)",
        "rgba(205, 195, 120, 0.5)",
        "rgba(185, 218, 255, 0.5)",
        "rgba(188, 205, 130, 0.5)",
        "rgba(128, 178, 205, 0.5)",
        "rgba(243, 255, 191, 0.5)",
        "rgba(100, 185, 182, 0.5)",
        "rgba(219, 157, 132, 0.5)",
        "rgba(165, 255, 249, 0.5)",
        "rgba(191, 170, 109, 0.5)",
        "rgba(193, 234, 255, 0.5)",
        "rgba(160, 179, 117, 0.5)",
        "rgba(185, 242, 255, 0.5)",
        "rgba(255, 213, 181, 0.5)",
        "rgba(124, 182, 173, 0.5)",
        "rgba(255, 236, 190, 0.5)",
        "rgba(160, 203, 211, 0.5)",
        "rgba(140, 183, 133, 0.5)",
        "rgba(223, 184, 179, 0.5)",
        "rgba(208, 255, 216, 0.5)",
        "rgba(206, 183, 160, 0.5)",
        "rgba(139, 180, 171, 0.5)",
        "rgba(249, 232, 205, 0.5)",
        "rgba(173, 174, 137, 0.5)",
      ],
    };
  },
  created() {
    if (screen.width <= 992) this.offset = 0;
    if (screen.width < 1200 && screen.width > 992) this.offset = 2;
    this.changed = false;
    this.loading = true;
    this.$store.state.secondaryDatabase
      .collection("shops")
      .where("owner", "==", firebase.auth().currentUser.uid)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = {
            id: doc.id,
            categories: doc.data().categories,
          };
          this.shops.push(data);
          this.categories = this.shops[0].categories;
          this.mainCategory = Object.keys(this.categories)[0];
          Object.keys(this.categories)
            .sort()
            .forEach((key, index) => this.mainCategories.push(key));
          Object.keys(this.categories[this.mainCategory])
            .sort()
            .forEach((subcat, index) => this.subCategories.push(subcat));

          const docRef = this.$store.state.secondaryDatabase.collection("stores");
          let firestoreQuery = docRef;
          if(this.$store.state.noDB === true) {
            firestoreQuery = firestoreQuery.where("shopOwner", "==", firebase.auth().currentUser.uid)
          } 
          firestoreQuery
            .get()
            .then((querySnapshot) => {
              querySnapshot.forEach((doc) => {
                const data = {
                  id: doc.id,
                  value: doc.id,
                  text: doc.data().name,
                  name: doc.data().name,
                };
                this.stores.push(data);
                this.storeLocation = this.$store.state.selectedStore; //this.stores[1].id; // store[1] bcz record with null values is added above
                console.log(this.stores, this.storeLocation);
              });
              this.getGraphData();
            })
            .catch((error) => alert(error.message));
          // handle inside getGraphData
          // this.changed = true;
          // this.loading = false;
        });
      })
      .catch((error) => alert(error.message));
  },
  methods: {
    handleMonth(date) {
      // console.log("date", date);
    },
    disabledDate(date) {
      return date > new Date();
    },
    getGraphData() {
      this.changed = false;
      this.loading = true;
      this.reports = [];
      this.datasets = [];
      this.labels = [];
      if (typeof this.year === "object") {
        this.year = this.year.getFullYear().toString();
      }
      // console.log("values", this.year, this.storeLocation, this.mainCategory);
      const date = new Date(this.year);
      const endDate = new Date(this.year, "11");
      const firstDay = new Date(date.getFullYear(), 0, 1);
      const firstDayClone = new Date(date.getFullYear(), 0, 1);
      const lastDay = new Date(date.getFullYear(), endDate.getMonth() + 1, 0);
      // console.log("dates", firstDay, lastDay);
      const dateStart = firstDayClone;
      const dateEnd = new Date();
      while (
        dateEnd > dateStart ||
        dateStart.toLocaleString("default", { month: "long" }) ===
          dateEnd.toLocaleString("default", { month: "long" })
      ) {
        this.labels.push(
          dateStart.toLocaleString("default", { month: "long" })
        );
        dateStart.setMonth(dateStart.getMonth() + 1);
      }
      // console.log("months", this.labels);
      this.$store.state.secondaryDatabase
        .collection("reports")
        .where("date", ">=", firebase.firestore.Timestamp.fromDate(firstDay))
        .where("date", "<=", firebase.firestore.Timestamp.fromDate(lastDay))
        .where("storeLocation", "==", this.storeLocation)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const data = {
              id: doc.id,
              date: doc.data().date,
              categories: doc.data().reportData,
              profitData: doc.data().profitData,
              totalPurcCost: +doc
                .data()
                .totalPurcCost.toFixed(2)
                .toLocaleString(),
              totalPurcDue: +doc
                .data()
                .totalPurcDue.toFixed(2)
                .toLocaleString(),
              totalSales: +doc.data().totalSales.toFixed(2).toLocaleString(),
              totalProfit: +doc.data().totalProfit.toFixed(2).toLocaleString(),
              totalRemaining: +doc
                .data()
                .totalRemaining.toFixed(2)
                .toLocaleString(),
              totalExp: +doc.data().totalExp.toFixed(2).toLocaleString(),
              month: doc
                .data()
                .date.toDate()
                .toLocaleString("default", { month: "long" }),
              netProfit: +(doc.data().totalProfit - doc.data().totalExp)
                .toFixed(2)
                .toLocaleString(),
            };
            this.reports.push(data);

            this.analyticsReport = this.reports[0].categories;
          });
          // Object.keys(this.categories).forEach((key, index) => {
          if (!this.subCategory) {
            Object.keys(this.categories[this.mainCategory]).forEach(
              (subcat, index) => {
                this.datasets.push({
                  label: subcat,
                  borderColor: this.colorArray[index],
                  pointBackgroundColor: "white",
                  pointBorderColor: "white",
                  borderWidth: 1,
                  backgroundColor: this.colorArray[index],
                  data: this.getDataset(subcat),
                });

                // // console.log("this.datasets", this.datasets);
              }
            );
          }
          if (this.subCategory) {
            this.datasets.push({
              label: this.subCategory,
              borderColor: this.colorArray[0],
              pointBackgroundColor: "white",
              pointBorderColor: "white",
              borderWidth: 1,
              backgroundColor: this.colorArray[0],
              data: this.getDataset(this.subCategory),
            });
          }
          // });
          this.getSalesData();
          // console.log("this.reports[0]", this.reports);
          if (!this.reports[0]) {
            this.isReportExsists = false;
            // this.categories = this.shops[0].categories;
            // Object.keys(this.categories).forEach((key, index) => {
            //   this.analyticsReport[key] = {};
            //   Object.keys(this.categories[key]).forEach(
            //     (subcat, index) => (this.analyticsReport[key][subcat] = 0)
            //   );
            // });
            // console.log("this.analyticsReport is", this.analyticsReport);
          }

          const monthlySalesByCategoryData = [];
          Object.keys(this.categories)
            .sort()
            .forEach((key, index) => {
              const monthlySalesByCategory = {};
              monthlySalesByCategory.id = index + 1;
              monthlySalesByCategory.category = key;
              // monthlySalesByCategory.sales = 0;
              // monthlySalesByCategory.profit = 0;
              monthlySalesByCategory.children = [];
              Object.keys(this.categories[key])
                .sort()
                .forEach((subcat, subindex) => {
                  const monthlyData = {};
                  this.reports.forEach((report) => {
                    monthlyData[
                      report.date
                        .toDate()
                        .toLocaleString("default", { month: "long" })
                    ] = {
                      sales: report.categories[key]
                        ? report.categories[key][subcat]
                          ? report.categories[key][subcat]
                          : 0
                        : 0,
                      profit: report.profitData[key]
                        ? report.profitData[key][subcat]
                          ? report.profitData[key][subcat]
                          : 0
                        : 0,
                    };
                  });
                  monthlySalesByCategory.children.push({
                    id: `${index + 1}-${subindex}`,
                    category: subcat,
                    salesProfit: monthlyData,
                    // sales: data.categories[key][subcat] ? data.categories[key][subcat] : 0,
                    // profit: data.profitData[key][subcat] ? data.profitData[key][subcat] : 0,
                  });
                });
              monthlySalesByCategoryData.push(monthlySalesByCategory);
            });
          monthlySalesByCategoryData.forEach((record) => {
            const monthlyData = {};

            this.reports.forEach((report) => {
              const month = report.date
                .toDate()
                .toLocaleString("default", { month: "long" });
              let totalSales = 0;
              record.children.forEach((item) => {
                totalSales += item.salesProfit[month].sales;
              });
              let totalProfit = 0;
              record.children.forEach((item) => {
                totalProfit += item.salesProfit[month].profit;
              });
              monthlyData[month] = {
                sales: totalSales,
                profit: totalProfit,
              };
            });
            record.salesProfit = monthlyData;
          });
          this.tableData = monthlySalesByCategoryData;
          console.log("monthlySalesByCategory", monthlySalesByCategoryData);

          this.changed = true;
          this.loading = false;
        })
        .catch((error) => console.log(error));
    },
    getSalesData() {
      this.barChartDataset[0].data = [
        ...this.labels.map((month) => {
          // console.log("reportFor", this.reports, month);
          const reportForMonth = this.reports.find((report) => {
            return (
              report.date
                .toDate()
                .toLocaleString("default", { month: "long" }) === month
            );
          });
          if (reportForMonth) {
            let totalSales = 0;
            Object.keys(this.categories).forEach((key, index) => {
              Object.keys(this.categories[key]).forEach((subcat, index) => {
                if (reportForMonth.categories[key]) {
                  totalSales += reportForMonth.categories[key][subcat];
                }
              });
            });
            return totalSales;
          }
          return 0;
        }),
      ];
      // console.log("this.barChartDataset", this.barChartDataset);
      return this.barChartDataset;
    },
    getDataset(subcat) {
      return [
        ...this.labels.map((month) => {
          const reportForMonth = this.reports.find(
            (report) =>
              report.date
                .toDate()
                .toLocaleString("default", { month: "long" }) === month
          );
          console.log("reportForMonth", reportForMonth);
          if (reportForMonth && reportForMonth.categories[this.mainCategory]) {
            return reportForMonth.categories[this.mainCategory][subcat];
          }
          return 0;
        }),
      ];
    },
  },
};
</script>

<style scoped>
@import url("~@/assets/admin/css/admin-loader.css");
.month-picker-input {
  padding: 0.57em 1.5em;
}
</style>s


// WEBPACK FOOTER //
// src/components/admin/Analytics.vue